<template>
  <v-layout wrap>
    <v-flex xs12 pb-2 class="subheading">
      <span>Specify alternative start time for daily statistics. </span>
    </v-flex>
    <v-flex xs12>
      <v-select :items="items" v-model="input" label="Start time for daily statistics"></v-select>
    </v-flex>
    <v-flex class="caption">
      Daily statistics will be calculated from {{ offsetValueText}} to {{ offsetValueText }}.
      <br />
      <template v-if="hasDateInfo">
        Report will query from
        <span class="font-weight-bold">{{ offsettedStartDateTimeText }}</span>
        to
        <span class="font-weight-bold">{{ offsettedEndDateTimeText }}</span>.
      </template>
    </v-flex>
  </v-layout>
</template>
<script>
  import moment from 'moment'
  import { times } from '@/helpers/timeSeries'
  import { prettyDateTimeFormatShort } from '@/components/mixins/MomentUtil'


  export default {
    props: {
      startDate: {
        required: true,
      },
      endDate: {
        required: true,
      },
      value: {
        required: false,
        default: 0,
      },
    },
    data() {
      return {
        items: times,
        input: 0,
      }
    },
    computed: {
      hasDateInfo() {
        return this.startDate && this.endDate
      },
      offsettedStartDateTime() {
        if (this.startDate == null) {
          return null
        }
        const startMoment = moment(this.startDate)
        return startMoment.startOf('day').add(this.input, 'hours')
      },
      offsettedEndDateTime() {
        if (this.endDate == null) {
          return null
        }
        const endMoment = moment(this.endDate)
        return endMoment.startOf('day').add(this.input, 'hours')
      },
      offsettedStartDateTimeText() {
        return this.offsettedStartDateTime && this.offsettedStartDateTime.format(prettyDateTimeFormatShort)
      },
      offsettedEndDateTimeText() {
        return this.offsettedEndDateTime && this.offsettedEndDateTime.format(prettyDateTimeFormatShort)
      },
      offsetValueText() {
        const matchedItem = this.items.find(x => x.value == this.input)
        return (matchedItem && matchedItem.text) || '0:00'
      },
    },
    watch: {
      input() {
        this.$emit('input', this.input)
      },
    },
    mounted() {
      this.input = this.value
    },
  }
</script>